import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import moment from 'moment';
import vuetify from './plugins/vuetify'

import Utils from './plugins/utils'
import interceptorsSetup from './utils/axiosInterceptors'
interceptorsSetup()

Vue.use(Utils)

// Axios interceptors for checking session token

if ('serviceWorker' in navigator) {
  navigator.serviceWorker.getRegistrations().then(registrations => {
    for (let registration of registrations) {
      registration.unregister().then(success => {
        if (success) {
          console.log('Service Worker desinstalado');
          window.location.reload();  // Forzar la recarga de la página
        }
      });
    }
  }).catch(error => {
    console.error('Error al desinstalar el Service Worker:', error);
  });
}else{
  console.log('No hay service worker');
  
}

Vue.config.productionTip = false

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')


